import { render, staticRenderFns } from "./WhatsappNumber.vue?vue&type=template&id=90cd6200&scoped=true&"
import script from "./WhatsappNumber.vue?vue&type=script&lang=js&"
export * from "./WhatsappNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cd6200",
  null
  
)

export default component.exports